import React, { useContext, useMemo } from "react";
import { useDate } from "../hooks/useDate";
export const DateContext = React.createContext();

export const DateProvider = ({ children }) => {
  const devicesState = useDate();
  const value = useMemo(() => devicesState, [devicesState]);

  return (
    <DateContext.Provider value={value}>{children}</DateContext.Provider>
  );
};

export function useDateContext() {
  return useContext(DateContext);
}
